import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import type {
  WebsiteContactInfoDto,
  WebsiteContentSnapshotDto,
  WebsitePageDto,
  WebsitePageListItemDto,
} from '../models/website-content/website-content.models';

@Injectable({ providedIn: 'root' })
export class WebsiteContentService {
  private readonly http = inject(HttpClient);

  private apiUrl(path: string): string {
    const base = environment.apiBaseUrl.replace(/\/+$/, '');
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${base}${p}`;
  }

  getSnapshot(): Observable<WebsiteContentSnapshotDto> {
    return this.http.get<WebsiteContentSnapshotDto>(this.apiUrl('/api/WebsiteContent/snapshot'));
  }

  getPages(): Observable<WebsitePageListItemDto[]> {
    return this.http.get<WebsitePageListItemDto[]>(this.apiUrl('/api/WebsiteContent/pages'));
  }

  getPage(slug: string): Observable<WebsitePageDto> {
    return this.http.get<WebsitePageDto>(this.apiUrl(`/api/WebsiteContent/pages/${encodeURIComponent(slug)}`));
  }

  getContactInfo(): Observable<WebsiteContactInfoDto> {
    return this.http.get<WebsiteContactInfoDto>(this.apiUrl('/api/WebsiteContent/contact'));
  }
}
